import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import RestManager from "../business/RestManager";
import Constants from "../business/Constants";

class AssociaNumeroCtrl extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.init();
    }
    init() {
        this.loadChildComponents(this);
        this.startLoader();

        GigyaManager.getLoggedUserCached().then((u) => {
            var ch = u.data[Constants.CH_PROMO];
            if(typeof ch !== "undefined" && ch != null && ch != ""){
                $('#regulationAcceptance').remove();
            }
            RestManager.userStatus().then((data) => {
                let win = data.response.data.contests[0].plays_stats.win;

                if(win.phone || win.web){
                    let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Hai già vinto, non puoi associare il numero di telefono!</h2>
                                                            <p>Ricorda che da regolamento puoi vincere solo una volta.</p>
                                                            <a href="/promozioni/vinci-il-buongiorno/area-personale" class="button">Torna all’area personale</a>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
                    $(this.element).append(tmplModalGeneric);
                    this.loadChildComponents(this);
                }

                this.removeLoader();
            }, (data)=>{
                this.removeLoader()
            })


        }, (err) => {
            window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
        })


    }

    submitForm(){

        if(!$('#conferma').prop("disabled")){
            $('#conferma').prop("disabled", true);

            $('.error-feedback').remove();
            $('input, select').removeClass('error');

            let validTelefono = this.take_telefono();
            let validAcceptance = this.take_acceptance();


            if(validAcceptance && validTelefono){
                var telefono = $('#telefono').val();
                if( $('#acceptance').length ) {
                    this.startLoader();
                    GigyaManager.addCH(Constants.CH_PROMO).then((resp) => {
                        this.doTelephoneAssociationCall(telefono);
                    }, (err) => {

                        let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>Ti preghiamo di riprovare più tardi!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
                        $(this.element).append(tmplModalGeneric);
                        this.loadChildComponents(this);
                        $('#conferma').prop("disabled", false);
                        this.removeLoader();
                    })
                } else{
                    this.startLoader();
                    this.doTelephoneAssociationCall(telefono);
                }
            }else{
                $('#conferma').prop("disabled", false);
            }

        }

    }

    doTelephoneAssociationCall(telephone){
        RestManager.associateTelephone(telephone).then((data)=>{

            window.location.href='/promozioni/vinci-il-buongiorno/hai-vinto?pt='+data.response.data.play_token+"&pm=3";
        }, (resp)=>{
            let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>${resp.status.errors.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
            $(this.element).append(tmplModalGeneric);
            this.loadChildComponents(this);
            $('#conferma').prop("disabled", false);
            this.removeLoader();
        });
    }

    take_telefono(){
        if( $('#telefono').length ){
            var telefono = $('#telefono').val();
            if (telefono.length < 2 & telefono !== undefined) {
                $('#telefono').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                var validTel = /^[0-9]+$/.test(telefono);
                if (!validTel) {
                    $('#telefono').addClass('error').after('<span class="error-feedback"><span' +
                        ' class="icon-error">!</span> Il campo deve essere composto' +
                        ' solo da' +
                        ' caratteri numerici</span>');
                }
                return true;
            }
        } else {
            return true;
        }
    }

    take_acceptance(){
        if( $('#acceptance').length ){
            if($('#acceptance').prop("checked") == false){
                $('#acceptance').addClass('error');
                $('.custom-row--acceptance').append('<span class="error-feedback"><span class="icon-error">!</span> Attenzione! Devi aver letto e accettato il regolamento.</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }


    removeLoader(){
        $('.tool_loader').fadeOut(500).remove();
        $('body').removeClass('noScroll');
    }

    startLoader(){
        $('.mb-promo-fette-2019').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
        $('body').addClass('noScroll');
    }

}

export default AssociaNumeroCtrl;
